<template>
  <loader-wrapper
    :loading="loading"
    spinner="el-icon-loading"
    @click.native="openTTN"
  >
    <template v-if="ttns.length">
      <el-row
        v-for="ttn in ttns"
        :key="ttn.id"
        :class="['flight-act', ttnStatus]"
      >
        {{ getTTNInfo(ttn) }}
      </el-row>
    </template>
    <div v-else class="flight-act danger">ТТН</div>
  </loader-wrapper>
</template>

<script>
import { mapGetters } from 'vuex'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

export default {
  name: 'FlightTTN',
  components: { LoaderWrapper },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    ttnStatus: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      getFlights: 'responses/getFlights',
      getLoading: 'responses/getLoading',
    }),
    loading() {
      return this.getLoading('TTN')
    },
    ttns() {
      return this.getFlights(this.id, 'TTN')
    },
  },
  methods: {
    openTTN() {
      if (!this.loading) {
        this.$emit('ttn')
      }
    },
    getTTNStatus(ttn) {
      const res = !ttn.brutto_fact || !ttn.img_url || !ttn.brutto_ttn

      return res ? 'warning' : 'success'
    },
    getTTNInfo(ttn) {
      const { number, date } = ttn
      const day = this.dateToFormat(date, 'shortDateWithoutYear')

      return number && day ? `ТТН ${number} от ${day}` : ''
    },
  },
}
</script>

<style lang="sass">
.flight-item
  .flight-act
    font-weight: bold
    position: relative
    text-align: center
    cursor: pointer
    &.danger
      color: #f00
    &.warning
      color: #ffb800
    &.success
      color: #00bf40
</style>
